module.exports = __webpack_public_path__ + "img/immersive.c2f6e4b2.webp";